<!-- 没有遮罩的dialog -->
<style scoped lang="less">
  .login-modal-x {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
  }

  .login-content-x {
    width: 100%;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: relative;
    z-index: 2;
  }

  .login-title {
    // color: #333;
    // text-align: center;
    // font-size: 20px;
    // font-weight: bold;
    font-size: 0;
  }

  .login-logo {
    width: 20%;
    display: block;
    margin: 0 auto;
    border-radius: 10px;
  }

  .user-phone {
    color: #333;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 1;
    margin-top: 24px;
  }

  .login-tip {
    color: #999;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    margin: 16px 0;
  }

  .xy-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    .p-xy {
      font-size: 10px;
      color: #5e5e5e;

      .xy {
        color: #4782ed;
      }
    }
  }

  .close-icon {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid;
    color: #adadad;
    font-size: 16px;
    margin-top: 20px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 2px;
      background-color: #adadad;
      height: 25px;
      top: 0;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
</style>

<template>
  <div class="login-modal-x">
    <div
      class="login-content-x"
      :style="{ backgroundImage: `url(${imgBaseUrl}/v1.0.1/login-bg.png)` }"
    >
      <div class="login-title">
        <img class="login-logo" :src="`${imgBaseUrl}/v1.0.3/logo.png`" alt="" />
      </div>
      <div class="form-x">
        <div class="user-phone">172****2849</div>
        <div class="login-tip">未注册手机号验证后将自动创建优客查查平台账号</div>
      </div>
      <div class="xy-box">
        <van-checkbox
          v-model="checked"
          icon-size="14px"
          checked-color="#4782ED"
          style="margin-right: 5px"
        ></van-checkbox>
        <p class="p-xy">
          <span>我已阅读并同意</span>
          <span
            v-for="(item, index) in agreementList"
            :key="index"
            class="xy"
            @click="viewAgreement(item)"
          >
            {{ item.name }}
          </span>
        </p>
      </div>
      <div class="login-btn-x">
        <van-space direction="vertical" fill>
          <van-button type="primary" block round @click="confirm">确认登录</van-button>
          <van-button type="default" plain block round>手机号码登录</van-button>
        </van-space>
      </div>
    </div>
    <div class="close-icon">
      <van-icon name="cross" @click="cancelModel" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { AgreementItem, useSmsCode } from '@/hooks';
  import { showToast } from 'vant';
  import { checkPhone } from '@/utils/utils';
  import { loginWithCode } from '@/api/basic';
  import { useLoginDialog } from '@/store';
  import { storage } from '@/utils/storage';
  import { buriedPointHook } from '@/hooks/buriedPoint';

  defineOptions({ name: 'LoginDialog' });
  withDefaults(defineProps<{ agreementList?: AgreementItem[] }>(), {
    agreementList: () => [],
  });
  const emits = defineEmits<{
    (e: 'cancelModel'): void;
    (e: 'confirm'): void;
    (e: 'viewAgreement', item: AgreementItem): void;
  }>();
  const imgBaseUrl = inject('imgBaseUrl');
  const loginDialogProps = useLoginDialog();
  const { codeInfo, getSmsCode, initCodeInfo } = useSmsCode();
  const { buriedOperationFn } = buriedPointHook();
  const checked = ref(false);
  const phone = ref('');

  const getCode = () => {
    if (!phone.value) return showToast('请填写手机号码');
    if (!checkPhone(phone.value)) return showToast('请填写正确的手机号码');
    getSmsCode({
      userPhone: phone.value,
      scene: 4,
      sendPlatform: 4,
    });
  };

  const viewAgreement = (item: AgreementItem) => emits('viewAgreement', item);
  const cancelModel = () => emits('cancelModel');
  const confirm = () => {
    if (!phone.value) return showToast('请填写手机号码');
    if (!checkPhone(phone.value)) return showToast('请填写正确的手机号码');
    if (!codeInfo.codeValue) return showToast('请填写验证码');
    if (!checked.value) return showToast('请勾选协议');
    loginWithCode(
      Object.assign(
        {
          userPhone: phone.value,
          code: codeInfo.codeValue,
          // loginType: 2, // 使用弹窗登录，和查询报告直接登录区分
        },
        loginDialogProps.loginParams
      )
    ).then((res) => {
      showToast('登录成功');
      const token = res ? res.token : undefined;
      token && storage.setItem('token', token);
      loginDialogProps.toLogin();
      // loginDialogProps.setIsLogin(true);
      // loginDialogProps.executeEvent('afterLogin');
      emits('confirm');
    });
  };

  defineExpose({
    initData: (state = false) => {
      if (!state) {
        phone.value = '';
        initCodeInfo();
        return;
      }
    },
  });
</script>
